import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos irmãos PJ). */
export type TermoCompromissoDirecaoPjJob = ReportJob;
export type TermoCompromissoDirecaoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Termo de Compromisso de Direção PJ. */
@Injectable({ providedIn: 'root' })
export class TermoCompromissoDirecaoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'termo-compromisso-direcao-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.termoCompromissoDirecaoPj;
}
